import { __extends } from "tslib";
import { GetVoiceTemplateRequest, GetVoiceTemplateResponse } from "../models/models_1";
import { deserializeAws_restJson1GetVoiceTemplateCommand, serializeAws_restJson1GetVoiceTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetVoiceTemplateCommand = /** @class */ (function (_super) {
    __extends(GetVoiceTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetVoiceTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetVoiceTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetVoiceTemplateCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetVoiceTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetVoiceTemplateResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetVoiceTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetVoiceTemplateCommand(input, context);
    };
    GetVoiceTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetVoiceTemplateCommand(output, context);
    };
    return GetVoiceTemplateCommand;
}($Command));
export { GetVoiceTemplateCommand };
//# sourceMappingURL=GetVoiceTemplateCommand.js.map